import React from 'react';

import { THEME } from '@constants/index';
import { openModal } from '@element/index'
import { I18n } from '@utils/index';

import styles from './index.module.less';

type IParams = {
  theme?: Theme
}

/** 确认放弃设置资金密码 */
export const openGiveUpSet = ({ theme = THEME.HIGHLIGHT }: IParams): Promise<'cancel' | 'ok'> => {
  return new Promise((resolve) => {
    openModal({
      title: I18n.t('tip'),
      theme,
      children: (
        (<div className={styles.main}>{I18n.t('pfNQ2XBb')}</div>)
      ),
      okText: I18n.t('forgetPass_step_three_confim'),
      cancelText: I18n.t('common_cancel'),
      onCancel: (close) => () => {
        close();
        resolve('cancel')
      },
      cancelButtonProps: {
        'data-buried': 'cancel-giveup-asset-password'
      },
      okButtonProps: {
        'data-buried': 'giveup-asset-password'
      },
      onOk: (close) => () => {
        close()
        resolve('ok')
      }
    })
  });
}
